import React from 'react';
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { mapChartColor } from 'components/forecast/forecastCharts/charts-color-mapper';
import { ChartInput } from 'components/forecast/forecastCharts/chart-input-selector';
import { autoFormatValue } from 'lib/value-formatter';

export function AppVerticalBarChart(props: { input: ChartInput }) {
  const input = props.input;
  const chart = props.input.chart;
  const data = props.input.data;

  const tooltipFormatter = (value: string, name: string, props: any) => {
    return valueFormatter(Number.parseFloat(value));
  };

  const valueFormatter = (value: number) => autoFormatValue(value);

  const isPrintView = props.input.isPrintView;
  const isAnimationActive = !isPrintView;

  return <ResponsiveContainer height="100%" width="99%">
    <BarChart
      data={data}
      layout="vertical"
    >
      <CartesianGrid
        strokeDasharray="4 4"
      />
      <XAxis
        fontSize={input.axisFontSize}
        height={60}
        tickFormatter={valueFormatter}
        type="number"
      >
      </XAxis>
      <YAxis
        offset={-3}
        fontSize={input.axisFontSize}
        width={120}
        type="category"
        dataKey={chart?.xAxisId}
      />
      <Legend
        verticalAlign="top"
        height={50}
        fontSize={input.axisFontSize}
        iconSize={20}
      />
      {
        !isPrintView &&
        <Tooltip
          formatter={tooltipFormatter}
          isAnimationActive={false}
        />
      }
      {
        chart && chart.dataSeries.map((ds, n) =>
          <Bar
            key={n}
            //stackId="a"
            name={ds.name}
            type="linear"
            dataKey={ds.id}
            fill={mapChartColor(ds.color)}
            strokeWidth={isPrintView ? 2 : 4}
            isAnimationActive={isAnimationActive}
          />,
        )
      }
    </BarChart>
  </ResponsiveContainer>;
}

export default AppVerticalBarChart;
